import { SidePanelType, useSidePanel, useSidePanelActions } from "PFApp/stores/side_panels_store";
import { CustomValuePreview } from "PFTypes";

export const useCustomValuePreviewActions = () => {
  const { open: showPreview, close: hidePreview } = useSidePanelActions<CustomValuePreview>(
    SidePanelType.CustomValuePreview
  );
  return { showPreview, hidePreview };
};

export const useCustomValuePreviewData = () =>
  useSidePanel<CustomValuePreview>(SidePanelType.CustomValuePreview);
